import React from "react";
import { comboItems } from "../data/landing";
import { SectionHead } from "./SectionHead";
export function ComboSummary() {
  return <section className="card" data-id="element-1" data-mp="1gqmcbhd3kot7">
      <SectionHead kicker="RESUMO DO COMBO COMPLETO" title="Tudo o que você recebe hoje" subtitle="A coleção completa + 4 bônus que cobrem desde o paciente acamado até a montagem da sessão inteira." data-id="element-2" data-mp="1uij2vgz4aqnh" />
      <div className="bgrid" data-id="element-3" data-mp="11t3g5ty3b9bq">
        {comboItems.map(item => <div className="bon" key={item.label} data-id="element-4" data-mp="xs9s90knduiu">
            <div className="bimg" data-id="element-5" data-mp="xtl65t7t4ino">
              <img src={item.img} alt={item.alt} loading="lazy" data-id="element-6" data-mp="xumj638dvf81" />
            </div>
            <div className="bcon" data-id="element-7" data-mp="1btchtnaupmyi">
              <div className="btop" data-id="element-8" data-mp="16t7xfm6to830">
                <span className="blab" data-id="element-9" data-mp="16s6lzglw9jkr">{item.label}</span>
                <span className="bfree" data-id="element-10" data-mp="2n77xqy9kxzqs">{item.badge}</span>
              </div>
              <h3 className="bh" data-id="element-11" data-mp="2n9as1uhrmf1b">{item.title}</h3>
              <p className="bd" data-id="element-12" data-mp="2i8wnwnjabp8k">{item.description}</p>
              <div className="bpt" data-id="element-13" data-mp="2iahek22hao15">
                {item.points.map(p => <span key={p} data-id="element-14" data-mp="3s1zgxai7ufrx">✦ {p}</span>)}
              </div>
            </div>
          </div>)}
      </div>
      <p className="cfoot" data-id="element-15" data-mp="5vakizeyxmxs">
        <i data-id="element-16" data-mp="5w2i2fs4luqp">✦</i> Os 4 bônus vêm incluídos no combo, sem custo extra.
      </p>
    </section>;
}